/**
 * Turns a function record into a status the UI can show honestly.
 *
 * The distinction that matters: a sheet being *uploaded* is not the same as
 * its rows being *in Naqood*. A single green tick for both was misleading, so
 * each state is named for what actually happened.
 */
export function functionStatus(fn) {
  const rows = fn?.rowCount ?? 0;
  const synced = fn?.syncedCount ?? 0;

  if (!fn || rows === 0) {
    return {
      key: "empty",
      label: "Upload a sheet",
      short: "",
      tone: "idle",
    };
  }

  if (synced === 0) {
    return {
      key: "ready",
      label: `${rows} row${rows === 1 ? "" : "s"} ready to push`,
      short: `${rows} ready`,
      tone: "ready",
    };
  }

  if (synced < rows) {
    return {
      key: "partial",
      label: `${synced} of ${rows} pushed`,
      short: `${synced}/${rows}`,
      tone: "partial",
    };
  }

  return {
    key: "pushed",
    label: `All ${rows} pushed to Naqood`,
    short: `${rows} pushed`,
    tone: "pushed",
  };
}
